import { message, Button } from 'antd';
import axios from "axios";
import store, {CART_COUNT_UPDATE, COMPARE_COUNT_UPDATE} from './store';

export const  addwishlist = async (productCode) => {
    const params = new URLSearchParams();
    params.append('token', localStorage.getItem('byos_token'));
    params.append('variantCode', productCode);
    try {
      const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/addtoWishlist',params);
       let resVal=response.data;
        if(resVal.status==='success'){
            message.success({
                content: resVal.message,
                className: 'notificationBox',
            });
        }else{
            message.error({
                content: resVal.message,
                className: 'notificationBox',
            });
        }
    } catch (error) {
      console.error(error);
    }

} 

export const removewishlist = async (productCode) => {
    const params = new URLSearchParams();
    params.append('token', localStorage.getItem('byos_token'));
    params.append('variantCode', productCode);
    try {
      const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/removefromWishlist',params);
       let resVal=response.data;
        if(resVal.status==='success'){
            message.success({
                content: resVal.message,
                className: 'notificationBox',
            });
        }else{
            message.error({
                content: resVal.message,
                className: 'notificationBox',
            });
        }
    } catch (error) {
      console.error(error);
    }
}


export const  addtocart = async (productId, variantId, quantity = 1) => {

    const params = new URLSearchParams();
    params.append('token', localStorage.getItem('byos_token'));
    params.append('productId', productId);
    params.append('variantId', variantId);
    params.append('quantity', quantity);
    try {
      const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/addtoCart',params);
       let resVal=response.data;
    //    console.log(resVal);
        if(resVal.status==='success'){
            message.success({
                content: resVal.message,
                className: 'notificationBox',
            });
            store.dispatch({ type:CART_COUNT_UPDATE, value:resVal.cartCount});
        }else{
            message.error({
                content: resVal.message,
                className: 'notificationBox',
            });
        }
    } catch (error) {
      console.error(error);
    }

} 


export const removecart = async (productCode) => {
    const params = new URLSearchParams();
    params.append('token', localStorage.getItem('byos_token'));
    params.append('variantCode', productCode);
    try {
      const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/removefromCart',params);
       let resVal=response.data;
        if(resVal.status==='success'){
            message.success({
                content: resVal.message,
                className: 'notificationBox',
            });
            store.dispatch({ type:CART_COUNT_UPDATE, value:resVal.cartCount});
        }else{
            message.error({
                content: resVal.message,
                className: 'notificationBox',
            });
        }
    } catch (error) {
      console.error(error);
    }
}


export const addtoCompare = (proTitle, proCode) => {
    if(!localStorage.getItem('ByosCompare1')){
        localStorage.setItem('ByosCompare1', proCode);
        message.success({
            content: proTitle+ " added to compare",
            className: 'notificationBox',
        });
    }else if(!localStorage.getItem('ByosCompare2')){
        localStorage.setItem('ByosCompare2', proCode);
        message.success({
            content: proTitle+ " added to compare",
            className: 'notificationBox',
        });
    }else if(!localStorage.getItem('ByosCompare3')){
        localStorage.setItem('ByosCompare3', proCode);
        message.success({
            content: proTitle+ " added to compare",
            className: 'notificationBox',
        });
    }else{
        message.error({
            content: "Only 3 products allowed to compare",
            className: 'notificationBox',
        });
    }

    /* compared vales count */
    store.dispatch({ type:COMPARE_COUNT_UPDATE, value:getCompareCount()});
}

export const removefromCompare = (proCode) => {
    if(localStorage.getItem('ByosCompare1')==proCode){
        localStorage.removeItem('ByosCompare1');
    }else if(localStorage.getItem('ByosCompare2')==proCode){
        localStorage.removeItem('ByosCompare2');
    }else if(localStorage.getItem('ByosCompare3')==proCode){
        localStorage.removeItem('ByosCompare3');
    }
    store.dispatch({ type:COMPARE_COUNT_UPDATE, value:getCompareCount()});
}

export const getCompare = () => {
    let FinalCompaValue=localStorage.getItem('ByosCompare1')+','+localStorage.getItem('ByosCompare2')+','+localStorage.getItem('ByosCompare3');
    return FinalCompaValue;
}

export const getCompareCount = () => {

    // console.log(localStorage.getItem('ByosCompare1'));
    // console.log(localStorage.getItem('ByosCompare2'));
    // console.log(localStorage.getItem('ByosCompare3'));
    let totCount=0;
    if(localStorage.getItem('ByosCompare1')){
        totCount=totCount+1;
    }
    if(localStorage.getItem('ByosCompare2')){
        totCount=totCount+1;
    }
    if(localStorage.getItem('ByosCompare3')){
        totCount=totCount+1;
    }
    return totCount;
}
